module.exports = __webpack_public_path__ + "static/Image21@2x-30d2ddb845f64cef9e65ac965b00040f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image21@2x.jpg
// module id = 914
// module chunks = 227233210825294 244429959259914